import { Component, Input, OnInit } from '@angular/core';
import { ApiFlowSection } from 'src/app/model/section/api-flow-section';

@Component({
  selector: 'app-revision-notices-affected-api-flow-section',
  templateUrl: './revision-notices-affected-api-flow-section.component.html',
  styleUrls: ['./revision-notices-affected-api-flow-section.component.scss']
})
export class RevisionNoticesAffectedApiFlowSectionComponent implements OnInit {
  @Input() sections: ApiFlowSection[] = [];
  @Input() isFareBandNameAndCodeOrderReshopPage: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
